import React, {useState, useContext, useEffect} from 'react';
import {Settings, File, Eye, Download, FileText} from 'lucide-react';
import {FamilyContext} from '../../Context/FamilyHeadContext';
import EssayManagement from './EssayManagement';
import DocumentViewer from './DocumentViewer';
import {useTranslation} from "react-i18next";
import {getCleanFileName, getFileType} from "../../utils/dateUtils";

const Essays = () => {
    const {isAuthenticated, currentFamilyHead} = useContext(FamilyContext);
    const [isManagementOpen, setIsManagementOpen] = useState(false);
    const [hoveredFile, setHoveredFile] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileType, setSelectedFileType] = useState(null);
    const [localFiles, setLocalFiles] = useState(currentFamilyHead.files || []);
    const {t} = useTranslation();

    const files = currentFamilyHead?.files || [];

    const handleFileAction = (e, file, action, fileType) => {
        e.stopPropagation();
        const fileUrl = `https://bazach.com${file}`;

        if (action === 'view') {
            setSelectedFileType(fileType);
            setSelectedFile(fileUrl);
        } else if (action === 'download') {
            fetch(fileUrl)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = getCleanFileName(file);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => console.error('שגיאה בהורדת הקובץ:', error));
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-[#f8f5f1] to-white">
            <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
                <h1 className="text-3xl font-bold text-[#937c5d] text-center mb-6">
                    {t('essays.title')} {currentFamilyHead?.name}
                </h1>

                {isAuthenticated && (
                    <div className="flex justify-end mb-8">
                        <button
                            onClick={() => setIsManagementOpen(true)}
                            className="group flex items-center gap-2 px-4 py-2 bg-[#937c5d]/10 text-[#937c5d]
                         rounded-full hover:bg-[#937c5d] hover:text-white transition-all duration-300"
                        >
                            <Settings className="w-5 h-5 group-hover:rotate-90 transition-transform duration-300"/>
                            <span className="hidden sm:inline">ניהול חיבורים</span>
                        </button>
                    </div>
                )}


                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {localFiles.map((file, index) => {
                        const fileName = getCleanFileName(file.filePath || file);
                        const fileType = getFileType(fileName);
                        const isPdf = fileType === 'application/pdf';

                        return (
                            <div
                                key={index}
                                className="relative group"
                                onMouseEnter={() => setHoveredFile(index)}
                                onMouseLeave={() => setHoveredFile(null)}
                            >
                                <div className="h-full p-4 bg-white rounded-xl shadow-sm hover:shadow-md
                          transition-all duration-300 border border-gray-100">
                                    <div className="flex flex-col h-full">
                                        <div className="flex items-start gap-3 mb-4">
                                            <div className="p-2 bg-[#937c5d]/10 rounded-lg">
                                                <FileText className="w-6 h-6 text-[#937c5d]"/>
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <h3 className="text-base font-medium text-gray-900 truncate dir-rtl">
                                                    {file.text || fileName}
                                                </h3>
                                                <p className="text-sm text-gray-500 mt-1">
                                                    {isPdf ? 'PDF' : 'Word'}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-end gap-2 mt-auto">
                                            <button
                                                onClick={(e) => handleFileAction(e, file, 'view', fileType)}
                                                className="p-2 text-[#937c5d] hover:bg-[#937c5d]/10 rounded-full
                                                         transition-colors duration-200"
                                                title="צפייה"
                                            >
                                                <Eye className="w-5 h-5"/>
                                            </button>
                                            <button
                                                onClick={(e) => handleFileAction(e, file, 'download', fileType)}
                                                className="p-2 text-[#937c5d] hover:bg-[#937c5d]/10 rounded-full
                                                         transition-colors duration-200"
                                                title="הורדה"
                                            >
                                                <Download className="w-5 h-5"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                    {localFiles.length === 0 && (
                        <div className="col-span-full flex flex-col items-center justify-center py-12 px-4">
                            <File className="w-12 h-12 text-gray-300 mb-3"/>
                            <p className="text-gray-500 text-center">אין קבצים להצגה</p>
                        </div>
                    )}
                </div>

                <DocumentViewer
                    isOpen={!!selectedFile}
                    onClose={() => {
                        setSelectedFile(null);
                        setSelectedFileType(null);
                    }}
                    fileUrl={selectedFile}
                    fileType={selectedFileType}
                />

                <EssayManagement
                    isOpen={isManagementOpen}
                    onClose={() => setIsManagementOpen(false)}
                    onSave={(updatedFiles) => {
                        // עדכון מגיע מהקונטקסט
                    }}
                    localFiles={localFiles}
                    setLocalFiles={setLocalFiles}
                />
            </div>
        </div>
    );
};

export default Essays;